// extracted by mini-css-extract-plugin
export default {"companiesWrapper":"Companies_companiesWrapper__8U7Ly","logo":"Companies_logo__x0w3o"};